import { render, staticRenderFns } from "./whatIfv4.vue?vue&type=template&id=08c833a9&scoped=true&"
import script from "./whatIfv4.vue?vue&type=script&lang=js&"
export * from "./whatIfv4.vue?vue&type=script&lang=js&"
import style0 from "./whatIfv4.vue?vue&type=style&index=0&id=08c833a9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c833a9",
  null
  
)

export default component.exports